import { httpClient } from 'utils/httpClient';
import {
  CategoriaCobro, CategoriaCobroPayload,
  ConceptoCobro, ConceptoCobroPayload,
  CobroAdicional, CobroAdicionalPayload, CobroAdicionalMasivoPayload,
  PagoCobroPayload,
} from 'types/pago.types';

// ============================================================
// cobrosAdicionalesService.ts – Categorías, Conceptos y Cobros adicionales
// ============================================================

// ── Categorías ────────────────────────────────────────────────

export const categoriaCobroService = {

  listar(): Promise<CategoriaCobro[]> {
    return httpClient.get<CategoriaCobro[]>('/categorias-cobro');
  },

  crear(payload: CategoriaCobroPayload): Promise<CategoriaCobro> {
    return httpClient.post<CategoriaCobro>('/categorias-cobro', payload);
  },

  actualizar(id: number, payload: CategoriaCobroPayload & { activo: boolean }): Promise<CategoriaCobro> {
    return httpClient.put<CategoriaCobro>(`/categorias-cobro/${id}`, payload);
  },
};

// ── Conceptos ─────────────────────────────────────────────────

export const conceptoCobroService = {

  listar(): Promise<ConceptoCobro[]> {
    return httpClient.get<ConceptoCobro[]>('/conceptos-cobro');
  },

  listarPorCategoria(categoriaId: number): Promise<ConceptoCobro[]> {
    return httpClient.get<ConceptoCobro[]>(`/conceptos-cobro/categoria/${categoriaId}`);
  },

  crear(payload: ConceptoCobroPayload): Promise<ConceptoCobro> {
    return httpClient.post<ConceptoCobro>('/conceptos-cobro', payload);
  },

  actualizar(id: number, payload: ConceptoCobroPayload & { activo: boolean }): Promise<ConceptoCobro> {
    return httpClient.put<ConceptoCobro>(`/conceptos-cobro/${id}`, payload);
  },
};

// ── Cobros adicionales ────────────────────────────────────────

export const cobroAdicionalService = {

  getById(id: number): Promise<CobroAdicional> {
    return httpClient.get<CobroAdicional>(`/cobros-adicionales/${id}`);
  },

  listarPorMatricula(matriculaId: number): Promise<CobroAdicional[]> {
    return httpClient.get<CobroAdicional[]>(`/cobros-adicionales/matricula/${matriculaId}`);
  },

  crear(payload: CobroAdicionalPayload): Promise<CobroAdicional> {
    return httpClient.post<CobroAdicional>('/cobros-adicionales', payload);
  },

  crearMasivo(payload: CobroAdicionalMasivoPayload): Promise<CobroAdicional[]> {
    return httpClient.post<CobroAdicional[]>('/cobros-adicionales/masivo', payload);
  },

  pagar(id: number, payload: PagoCobroPayload): Promise<CobroAdicional> {
    return httpClient.patch<CobroAdicional>(`/cobros-adicionales/${id}/pagar`, payload);
  },

  anular(id: number): Promise<CobroAdicional> {
    return httpClient.patch<CobroAdicional>(`/cobros-adicionales/${id}/anular`, {});
  },
};
